'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Utils


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _lodash = require('lodash');

var _domUtil = require('../../utils/domUtil');

var _lineSnapAngleUtil = require('./lineSnapAngleUtil');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _EdgeDragHandle = require('./EdgeDragHandle');

var _EdgeDragHandle2 = _interopRequireDefault(_EdgeDragHandle);

var _lineConstants = require('../../../common/lines/lineConstants');

var _dndConstants = require('../../utils/dnd/dndConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var edgeDragSource = {
    beginDrag: function beginDrag(_ref) {
        var edge = _ref.edge,
            elementId = _ref.elementId,
            toggleLineVisibility = _ref.toggleLineVisibility,
            pos = _ref.pos,
            element = _ref.element;

        (0, _lodash.defer)(toggleLineVisibility);
        return { id: elementId, element: element, edge: edge, pos: pos };
    },
    endDrag: function endDrag(props, monitor) {
        var updateLineEdge = props.updateLineEdge,
            edge = props.edge,
            pos = props.pos,
            gridSize = props.gridSize,
            toggleLineVisibility = props.toggleLineVisibility,
            origin = props.origin,
            dragModifierKeys = props.dragModifierKeys;

        // Doing nothing if it was not dropped onto a compatible target

        var dropResult = monitor.getDropResult();
        if (!monitor.didDrop() || (0, _lodash.isEmpty)(dropResult)) {
            toggleLineVisibility();
            return;
        }

        var _dropResult$offsetDif = dropResult.offsetDiff,
            offsetDiff = _dropResult$offsetDif === undefined ? _dndConstants.NO_DRAG_OFFSET : _dropResult$offsetDif,
            snapped = dropResult.snapped,
            elementId = dropResult.elementId;


        var newPositionPx = pointLib.translate(offsetDiff, pos);
        var shouldSnapToAngle = dragModifierKeys.get('shiftKey');

        if (shouldSnapToAngle) {
            newPositionPx = (0, _lineSnapAngleUtil.getEndpointSnappedToAngle)({
                fixedPoint: origin,
                flexiblePoint: newPositionPx
            });
        }

        var newPosition = {
            x: Math.round(newPositionPx.x / gridSize),
            y: Math.round(newPositionPx.y / gridSize),
            snapped: !!snapped
        };

        if (snapped) {
            newPosition.elementId = elementId;
        }

        updateLineEdge({ edge: edge, newPosition: newPosition });
        toggleLineVisibility();
    }
};

var dragCollect = function dragCollect(connector, monitor) {
    return {
        // Call inside render() to let React handle the drag event
        connectDragSource: connector.dragSource(),
        connectDragPreview: connector.dragPreview(),
        // Get current drag state from the monitor
        isDragging: monitor.isDragging()
    };
};

var EdgeDragHandleDragSource = (_dec = (0, _reactDnd.DragSource)(_lineConstants.LINE_EDGE_DND_TYPE, edgeDragSource, dragCollect), _dec(_class = function (_React$Component) {
    _inherits(EdgeDragHandleDragSource, _React$Component);

    function EdgeDragHandleDragSource() {
        _classCallCheck(this, EdgeDragHandleDragSource);

        return _possibleConstructorReturn(this, (EdgeDragHandleDragSource.__proto__ || Object.getPrototypeOf(EdgeDragHandleDragSource)).apply(this, arguments));
    }

    _createClass(EdgeDragHandleDragSource, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_EdgeDragHandle2.default, this.props);
        }
    }]);

    return EdgeDragHandleDragSource;
}(_react2.default.Component)) || _class);

/**
 * Needs to be a React component so that the parent's (Line) ref connects correctly.
 */
/* eslint-disable react/no-multi-comp */

var ConnectedEdgeDragHandle = function (_React$Component2) {
    _inherits(ConnectedEdgeDragHandle, _React$Component2);

    function ConnectedEdgeDragHandle() {
        _classCallCheck(this, ConnectedEdgeDragHandle);

        return _possibleConstructorReturn(this, (ConnectedEdgeDragHandle.__proto__ || Object.getPrototypeOf(ConnectedEdgeDragHandle)).apply(this, arguments));
    }

    _createClass(ConnectedEdgeDragHandle, [{
        key: 'render',
        value: function render() {
            var show = this.props.show;

            if (!show) return null;

            return _react2.default.createElement(EdgeDragHandleDragSource, _extends({ onMouseDown: _domUtil.stopPropagationOnly, isHitArea: true }, this.props));
        }
    }]);

    return ConnectedEdgeDragHandle;
}(_react2.default.Component);

ConnectedEdgeDragHandle.propTypes = {
    show: _propTypes2.default.bool,
    pos: _propTypes2.default.object,
    edge: _propTypes2.default.string.isRequired,
    elementId: _propTypes2.default.string.isRequired,
    updateLineEdge: _propTypes2.default.func,
    toggleLineVisibility: _propTypes2.default.func,
    gridSize: _propTypes2.default.number,
    origin: _propTypes2.default.object
};

exports.default = ConnectedEdgeDragHandle;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/ConnectedEdgeDragHandle.js
// module id = 1988
// module chunks = 0